import { useCallback, useRef } from 'react';

export const useSound = () => {
  const audioRef = useRef<AudioContext | null>(null);

  const playNotification = useCallback(async () => {
    try {
      const audioContext =
        audioRef.current ??
        new (window.AudioContext || (window as any).webkitAudioContext)();
      audioRef.current = audioContext;

      if (audioContext.state === 'suspended') {
        await audioContext.resume();
      }

      const createTone = (
        frequency: number,
        startTime: number,
        duration: number,
      ) => {
        const oscillator = audioContext.createOscillator();
        const gainNode = audioContext.createGain();

        oscillator.connect(gainNode);
        gainNode.connect(audioContext.destination);

        oscillator.frequency.value = frequency;
        oscillator.type = 'sine';

        gainNode.gain.setValueAtTime(0.2, startTime);
        gainNode.gain.exponentialRampToValueAtTime(0.01, startTime + duration);

        oscillator.start(startTime);
        oscillator.stop(startTime + duration);
        // Clean-up once the note finishes
        oscillator.onended = () => {
          oscillator.disconnect();
          gainNode.disconnect();
        };
      };

      createTone(800, audioContext.currentTime, 0.2);
      createTone(1000, audioContext.currentTime + 0.25, 0.2);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Erro ao reproduzir notificação:', error);
    }
  }, []);

  return { playNotification };
};
